// extracted by mini-css-extract-plugin
export default {"card-services":"HDI_card-services__shdZ+","item_hdi":"HDI_item_hdi__1Idek"};